/**
 * @generated SignedSource<<8ba4ff7a3e10c40f5e65f9bf6b9241d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LeadsFiltersStagesQuery$variables = {
  pipelineId: string;
};
export type LeadsFiltersStagesQuery$data = {
  readonly stages: ReadonlyArray<{
    readonly id: string;
    readonly label: string;
  }> | null;
};
export type LeadsFiltersStagesQuery = {
  response: LeadsFiltersStagesQuery$data;
  variables: LeadsFiltersStagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pipelineId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pipelineId",
        "variableName": "pipelineId"
      }
    ],
    "concreteType": "LeadStage",
    "kind": "LinkedField",
    "name": "stages",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LeadsFiltersStagesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LeadsFiltersStagesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cefb40be94a50d620bc44ad969b31323",
    "id": null,
    "metadata": {},
    "name": "LeadsFiltersStagesQuery",
    "operationKind": "query",
    "text": "query LeadsFiltersStagesQuery(\n  $pipelineId: ID!\n) {\n  stages(pipelineId: $pipelineId) {\n    id\n    label\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ea28c4345e9ca0a386e6bd4bebc92b8";

export default node;
